// SERP title/description builders for California and Washington waste-code
// pages. Code-first titles, same rationale as txSeoMeta.ts / rcraSeoMeta.ts.
import type { CaWasteCodeEntry } from './caWasteCatalogue';
import type { WaWasteCodeEntry } from './waWasteCatalogue';

function truncateLabel(text: string, max: number, ellipsis = '…'): string {
  const t = text.replace(/\s+/g, ' ').trim();
  if (t.length <= max) return t;
  const cut = t.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');
  return `${cut.slice(0, lastSpace > 20 ? lastSpace : max).replace(/[,;:.\s]+$/, '')}${ellipsis}`;
}

function titleCase(s: string): string {
  return s.replace(/\w\S*/g, (w) => w.length > 2 ? w[0].toUpperCase() + w.slice(1) : w);
}

function cleanLabel(description: string, max: number): string {
  const clean = description.replace(/\s*\([^)]*\)/g, '').trim();
  return truncateLabel(titleCase(clean), max, '');
}

export function caTitle(entry: CaWasteCodeEntry): string {
  const base = `CA Waste Code ${entry.code} — ${cleanLabel(entry.description, 34)}`;
  return base.length <= 56 ? `${base} | SymbioFlows` : base;
}

export function caOgTitle(entry: CaWasteCodeEntry): string {
  return `California Waste Code ${entry.code} — ${cleanLabel(entry.description, 60)}`;
}

export function caMetaDescription(entry: CaWasteCodeEntry): string {
  const what = truncateLabel(entry.description, 70);
  const tail = ' Manifest coding and recovery options under 22 CCR Appendix XII.';
  return truncateLabel(`California waste code ${entry.code}: ${what}.`, 158 - tail.length) + tail;
}

export function waTitle(entry: WaWasteCodeEntry): string {
  const base = `${entry.code} Waste Code — ${cleanLabel(entry.description, 34)}`;
  return base.length <= 56 ? `${base} | SymbioFlows` : base;
}

export function waOgTitle(entry: WaWasteCodeEntry): string {
  return `Washington ${entry.code} — ${cleanLabel(entry.description, 60)}`;
}

export function waMetaDescription(entry: WaWasteCodeEntry): string {
  const what = truncateLabel(entry.description, 70);
  const tail = ' Washington designation and recovery options under WAC 173-303.';
  return truncateLabel(`${entry.code}: ${what}.`, 158 - tail.length) + tail;
}
